module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "thebody"
    }
  }, [_c('lrHeader', {
    attrs: {
      "theHeader": _vm.headerMsg
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('lrInput', {
    attrs: {
      "theInput": _vm.inputMsg
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "theCenter"
    }
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-cd006974", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-cd006974","hasScoped":true}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/router/plogin.vue
// module id = 186
// module chunks = 0